/* global axios */
import { readBlobError } from './errors';

// Same "read the account id out of the URL" convention as the base
// ApiClient, so every thin API function stays free of an accountId argument.
function accountIdFromPath() {
  const isInsideAccountScopedURLs =
    window.location.pathname.includes('/app/accounts');
  if (isInsideAccountScopedURLs) {
    return window.location.pathname.split('/')[3];
  }
  return '';
}

// The Vue app never calls singabot directly: it goes through the Rails
// knowledge proxy. The account id appears twice, once for Rails and once for
// singabot. Two path prefixes live behind the proxy: the field-service
// engine (settings, calendar, SLA, roles, team, categories, routing, tickets,
// visits) and the co-living vertical (condos, units, tenants, manual ticket).
export function engineUrl(accountId, path) {
  return `/api/v1/accounts/${accountId}/proxy/knowledge/field-service/accounts/${accountId}${path}`;
}

export function verticalUrl(accountId, path) {
  return `/api/v1/accounts/${accountId}/proxy/knowledge/co-living/accounts/${accountId}${path}`;
}

// `data` may be a FormData (the browser then sets the multipart boundary, so
// no Content-Type is set here). `responseType: 'blob'` is for downloads: the
// proxy drops Content-Disposition, so the caller names the file, and an error
// body arrives as a Blob that is turned back into JSON before it is thrown.
async function send(
  buildUrl,
  { method = 'get', path, params, data, responseType } = {}
) {
  const accountId = accountIdFromPath();
  const config = { method, url: buildUrl(accountId, path), params };
  if (data !== undefined) {
    config.data = data;
  }
  if (responseType) {
    config.responseType = responseType;
  }
  // Session headers (access-token/client/uid) are added by the axios
  // interceptor in helper/APIHelper.js. Never send api_access_token here:
  // the portal routes refuse it with 403.
  try {
    const response = await axios(config);
    return { data: response.data, status: response.status };
  } catch (err) {
    throw responseType === 'blob' ? await readBlobError(err) : err;
  }
}

export const engineRequest = options => send(engineUrl, options);
export const verticalRequest = options => send(verticalUrl, options);
